import Vue from 'vue';
import Vuelidate from 'vuelidate';
import number from '@coders-tm/vue-number-format';
import App from './App.vue';

Vue.use(Vuelidate);
Vue.use(number, { precision: 4 });
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
